import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import { ArrowRight, CheckCircle, Info } from "lucide-react";
import useReveal from "../common/useReveal";
import "./referralProgram.css";

const ReferralProgram = () => {
	const { language } = useContext(CombinedContext);
	const navigate = useNavigate();
	const rootRef = useReveal();

	const t = translations[language].referralProgram;

	return (
		<div className="sf-rp-root" ref={rootRef}>
			{/* ── HERO ── */}
			<section className="sf-rp-hero">
				<div className="sf-rp-hero-grid" aria-hidden="true"></div>
				<div className="sf-rp-hero-inner">
					<h1>{t.title}</h1>
					<p className="sf-rp-tagline">{t.tagline}</p>
				</div>
			</section>

			<div className="sf-rp-page">
				{/* ── HOW IT WORKS (lede) ── */}
				<section className="sf-rp-lede" data-reveal>
					<h2>{t.howItWorks.heading}</h2>
					<p>{t.howItWorks.text}</p>
				</section>

				{/* ── THE TWO SIDES OF A REFERRAL ── */}
				<section className="sf-rp-rewards">
					<div className="sf-rp-reward-card sf-rp-reward-gold" data-reveal>
						<div className="sf-rp-reward-icon" aria-hidden="true">💵</div>
						<h3>{t.ifYouRefer.heading}</h3>
						<p className="sf-rp-reward-lead">{t.ifYouRefer.text}</p>
						{/* <ul className="sf-rp-reward-list">
							{t.ifYouRefer.bullets.map((item, i) => (
								<li key={i}>
									<CheckCircle size={16} className="sf-rp-check" />
									<span>{item}</span>
								</li>
							))}
						</ul> */}
					</div>

					<div className="sf-rp-reward-card sf-rp-reward-sky" data-reveal>
						<div className="sf-rp-reward-icon" aria-hidden="true">🎁</div>
						<h3>{t.ifYouWereReferred.heading}</h3>
						<p className="sf-rp-reward-lead">{t.ifYouWereReferred.text}</p>
					</div>
				</section>

				{/* ── HOW TO REFER (stepper) ── */}
				<section className="sf-rp-steps-section">
					<div className="sf-rp-section-head" data-reveal>
						<h2>{t.howToRefer.heading}</h2>
					</div>

					<ol className="sf-rp-steps">
						{t.howToRefer.steps.map((step, i) => (
							<li key={i} className="sf-rp-step" data-reveal>
								<div className="sf-rp-step-num">{i + 1}</div>
								<p>{step}</p>
							</li>
						))}
					</ol>
				</section>

				{/* ── GOOD TO KNOW ── */}
				<section className="sf-rp-gtk">
					<div className="sf-rp-section-head" data-reveal>
						<h2>{t.goodToKnow.heading}</h2>
					</div>

					<div className="sf-rp-gtk-grid">
						{t.goodToKnow.bullets.map((item, i) => (
							<div className="sf-rp-gtk-card" key={i} data-reveal>
								<Info size={17} className="sf-rp-gtk-icon" />
								<p>{item}</p>
							</div>
						))}
					</div>
				</section>

				{/* ── CLOSING ── */}
				<section className="sf-rp-cta" data-reveal>
					<p>{t.cta.text}</p>
					<button className="sf-rp-btn-primary" onClick={() => navigate("/listyourshop")}>
						{t.cta.button}
						<ArrowRight size={18} className="sf-rp-btn-arrow" />
					</button>
				</section>
			</div>
		</div>
	);
};

export default ReferralProgram;
